<template>


<v-container v-if="isLoading == true">
 <div id="fb-root"></div>

  <v-layout justify-center>
    <div class="white-widget grey-bg author-area">
    <div class="auth-info row">
    <div class="timeline-wrapper">
    <div class="timeline-item">
        <div class="animated-background">
            <div class="background-masker header-top"></div>
            <div class="background-masker header-left"></div>
            <div class="background-masker header-right"></div>
            <div class="background-masker header-bottom"></div>
    
        </div>
    </div>
    </div>
    </div>
    </div>
  </v-layout>
    
</v-container>

 <v-container v-else class="mb-5 pa-0" fluid style="background-color:#FAFAFA">

     <div style="position:fixed; height:30vh
; width:100vw" class="hidden-sm-and-down header_gray">

     </div>
     <v-layout justify-center>
         <v-flex xs12 md9>

         
    <v-card dark class="">
        <v-card-media class="white--text"    v-bind:class="{'largeScreenHeight' : getScreenWidth() > 900, 'smallScreenHeight' : getScreenWidth() < 900}" :src="artefact.mainImg[0].url+'_single'">
            <div class="mainImg-overlay" style="">

            </div>
          <v-container fill-height fluid class="pr-1 pl-1">
            <v-layout fill-height column class="media">
              <!-- <v-flex xs12 align-start>
                <v-icon class="body-1 white--text">library_books</v-icon> <span class="body-1 white--text" v-for="items in artefact.collectionId" :key="items" > {{items}}</span>
              </v-flex> -->
                <v-card-actions>
                    <v-layout row>
                        <v-icon dark>view_carousel</v-icon>
                        <v-icon class="ml-3" dark>remove_red_eye</v-icon><p style="font-size: 16px;margin-left: 6px;
    padding-top: 15px;">{{artefact.uniqueVisits.length}}</p>

                    </v-layout>
                    
                    <v-layout v-if="isAdmin && isAccepted"><v-spacer></v-spacer>
                        <v-btn flat class="headerButtons" icon  @click="addToFav"><v-icon dark v-if="!favorited" >favorite_border</v-icon><v-icon dark v-else >favorite</v-icon></v-btn>
                        <v-btn flat class="headerButtons" icon :to="'/artefacts/edit/' + artefact._id"><v-icon dark>edit</v-icon></v-btn>
                        <v-btn flat class="headerButtons" icon @click.native.stop="dialog = true" ><v-icon dark >delete</v-icon></v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                               <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                                <v-card-text>{{gLang[lang].artefactSingle.delete}}</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">{{gLang[lang].artefactSingle.btnno}}</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteArtefact" >{{gLang[lang].artefactSingle.btnyes}}</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>

                    </v-layout>
                    <v-layout v-else-if="(isAdmin && !isAccepted) || (isMod && !isAccepted) "><v-spacer></v-spacer>
                        <v-btn class="headerButtons" flat icon @click="acceptArtefact"><v-icon dark  >check_circle</v-icon></v-btn>
                        <v-btn class="headerButtons" flat icon :to="'/artefacts/edit/' + artefact._id"><v-icon dark  >edit</v-icon></v-btn>
                        <v-btn class="headerButtons" flat icon @click.native.stop="dialog = true" ><v-icon dark >delete</v-icon></v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                               <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                                <v-card-text>{{gLang[lang].artefactSingle.delete}}</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">{{gLang[lang].artefactSingle.btnno}}</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteArtefact" >{{gLang[lang].artefactSingle.btnyes}}</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>

                    </v-layout>
                    <v-layout v-else-if="!isAdmin && !isAccepted "><v-spacer></v-spacer></v-layout>
                    <v-layout v-else-if="!isAdmin && isAccepted && isAuthor "><v-spacer></v-spacer>
                        <v-btn class="headerButtons" flat icon @click="addToFav"><v-icon dark v-if="!favorited" >favorite_border</v-icon><v-icon dark v-else >favorite</v-icon></v-btn>
                        <v-btn class="headerButtons" flat icon :to="'/artefacts/edit/' + artefact._id"><v-icon dark>edit</v-icon></v-btn>
                        <v-btn class="headerButtons" flat icon @click.native.stop="dialog = true"><v-icon dark  >delete</v-icon></v-btn>

                        <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                               <!-- <v-card-title class="headline">Are you sure you want to delete this artefact?</v-card-title> -->
                                <v-card-text>{{gLang[lang].artefactSingle.delete}}</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">{{gLang[lang].artefactSingle.btnno}}</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteArtefact" >{{gLang[lang].artefactSingle.btnyes}}</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>

                    </v-layout>
                    <v-layout v-else-if="!isAdmin && isAccepted && !isAuthor && isLoggedIn "><v-spacer></v-spacer>
                        <v-btn class="headerButtons" flat icon @click="addToFav"><v-icon dark v-if="!favorited" >favorite_border</v-icon><v-icon dark v-else >favorite</v-icon></v-btn>
                    </v-layout>
                    <v-layout v-else-if="!isAdmin && isAccepted && !isAuthor && !isLoggedIn "><v-spacer></v-spacer>
                    </v-layout>

                </v-card-actions>
                <v-card-title >
                    <v-layout >
                    <v-list-tile-content >
                        <div class="v-list-tile-content">
                        <v-list-tile-title class="display-1 v-list-tile-title" >{{artefact.title[lang].toUpperCase()}}</v-list-tile-title>
                        <v-list-tile-sub-title v-for="user in users" :key="user._id" v-if="user._id == artefact.userId " class="pb-2 pt-2 caption">{{gLang[lang].artefactSingle.addedBy}} {{user.displayName}} at {{artefact.meta.creationDate | date}} </v-list-tile-sub-title>
                        <hr width="100%">
                        <v-list-tile-sub-title class="pb-2 pt-2 caption" >
                            <v-layout row wrap>
                            
                               
                            <span v-for="(col,i) in  artefact.collectionId " :key="i" v-if="i<7 && getLanguageTranslation(col)!=false" ><div style="cursor:pointer;" @click="goToCollectionByName(col)"> &nbsp; <v-icon left dark >label</v-icon>{{getLanguageTranslation(col)}}</div></span>
                            <!-- <v-flex xs4><span><v-icon left dark >label</v-icon> {{artefact.collectionId[1]}}</span></v-flex> -->
                                
                            </v-layout>
                            </v-list-tile-sub-title>
                        </div>
                    </v-list-tile-content>
                    
                    </v-layout>
                </v-card-title>
            </v-layout>
          </v-container>
        </v-card-media>
    </v-card>


<v-card style="background-color:white;" class="hidden-sm-and-down addBorder" flat>
          <v-card-text class="pr-0 pl-0">

	 
  <div class="description pa-3">
      <p>{{artefact.description[lang]}}</p>
  </div>











<v-layout row wrap justify-center class="">
    <div class="div1"  v-for="media in artefact.uploads" :key="media._id">
        <v-flex xs12 sm12 v-if="media.type ==='image'"> 
            <div class=" position:relative"  >
                <img class="img1" :src="media.data[0].url+'_single'" alt="">       
            </div>
        </v-flex>      
      <v-flex elevation-1 class="mt-3 mb-3" xs12 sm12 v-else-if="media.type === 'video'">
        <v-card>
         <div >
        <v-card-media>
      <v-layout justify-center >
        <!-- <d-player :video='{
                url: media.data[0].url,
                  }'
                :autoplay="false"
                :contextmenu="contextmenu"
                screenshot: true
                lang = "en"
                @play="play"
                ref="player">
        </d-player >   -->

        <video style="width:100%; height:100%" controls  >
  <source :src="media.data[0].url + '.mp4'" type="video/mp4">
  <source :src="media.data[0].url + '.webm'" type="video/webm">
  <source :src="media.data[0].url + '.m4v'" type="video/m4v">
  <source :src="media.data[0].url + '.ogg'" type="video/ogg">
Your browser does not support the video tag.
</video>
      </v-layout>
      </v-card-media> 
      </div>    
      </v-card>
      </v-flex>











    
      <v-flex v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'mt-3 mb-3 img1' : true} " xs12  v-else-if="media.type === 'audio'">
            <div v-if="media.data.length != 0" class="">  
      <!-- <v-layout row style="width:100%; overflow:hidden; white-space:normal">

      <v-layout  class="">
      
      <div  class="" style="width:100%; overflow:hidden" >
        <a-player elevation-0 class="aplayer-style" style="width:100%; overflow:hidden"  :music="{
                            title: media.data[0].originalName,
                            author: ' ',
                            url: media.data[0].url,
                            pic: 'http://lectii-photoshop.com/wp-content/uploads/photo-shop/Lectii_Articole/Grafica%20pentru%20site/Music%20Icon/Music%20Icon-31.jpg',    
                            }">
        </a-player>
      </div>
      </v-layout>
      </v-layout> -->

      <v-layout justify-center>
          <v-flex xs12 md6>
              <v-layout row elevation-3 class="pa-1" style="background-color:#FAFAFA">
              
                    <div style="width:100%; background-color:#FAFAFA">
 <v-layout class="" row style="width:100%; white-space:normal; ">
                  <v-flex xs12>
                        <p> <i>{{media.data[0].originalName}}</i> </p>
                </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                    <audio controls style="width:100%; ">
                             <source :src="media.data[0].url" type="audio/ogg">
                            <source :src="media.data[0].url" type="audio/mpeg">
                                {{gLang[lang].artefactSingle.browser}}
                    </audio>

                    <!-- <audio id="player" :src="media.data[0].url"></audio>
<div> 
  <button onclick="document.getElementById('player').play()">Play</button> 
  <button onclick="document.getElementById('player').pause()">Pause</button> 
  <button onclick="document.getElementById('player').volume += 0.1">Vol+ </button> 
  <button onclick="document.getElementById('player').volume -= 0.1">Vol- </button> 
</div> -->
           </v-flex>
           
        

            </v-layout>
                </div>
                  
                
            </v-layout>
          </v-flex>
      </v-layout>

            
      
            
 
         </div>
       
      </v-flex>








      
      <v-flex    v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'mr-0  mt-2 mb-2  flex1' : true} "   xs12 sm12 v-else-if="media.type === 'pdf'">
          <div v-if="media.data.length != 0">  
      <v-layout row wrap justify-center>

          <v-flex xs12 sm10 md6 offset>
      <v-card style="box-shadow:none; border-bottom:1px solid #efefef">
          <v-list two-line>
              <v-list-tile >
            <v-list-tile-avatar >
              <v-icon class="blue white--text pt-2"> picture_as_pdf</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{media.data[0].originalName}}</v-list-tile-title>
              <v-list-tile-sub-title>{{artefact.meta.creationDate | date}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn :href="media.data[0].url" download icon ripple>
                <v-icon  color="grey lighten-1">file_download</v-icon>
              </v-btn>
              <v-btn @click="viewPDF = !viewPDF" icon ripple>
                <v-icon v-if="!viewPDF" color="grey lighten-1">visibility</v-icon>
                <v-icon v-else color="grey lighten-1">visibility_off</v-icon>
                
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          </v-list>
          <iframe v-if="viewPDF" :src=" 'http://docs.google.com/viewer?url=' + 'hera.uvt.ro' +  media.data[0].url   +  '.pdf' + '&embedded=true'" width="600" height="780" style="border: none;"></iframe>
      
        <!-- <iframe id="iframepdf" src="bitcoin.org/bitcoin.pdf"></iframe> -->
      </v-card></v-flex>

      </v-layout>


          </div>
      </v-flex>


      
      <v-flex class="mt-2 mb-2 mr-1 ml-1 pt-1 pb-1" xs12 sm12 v-else-if="media.type === 'text'">


      
      
      <div  class="" >
        <div class="description pt-3 pl-3 pr-3 pb-0">
       <p style="word-break: break-all;" v-html="media.value[lang]" ></p>
       </div>

      
      </div>

      </v-flex>

      

   
       </div>

     
</v-layout>



      <v-speed-dial id="bottom_button" class="app-vue-speeddial"   v-if="isMod||isContrib" 
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :hover="hover"
      :transition="transition"
      fixed
    >
      <v-btn class="ma-1"
        slot="activator"
        color="primary"
        dark
        fab
        hover
        v-model="fab"
        to='/artefacts/new'
      >
        <v-icon>add</v-icon>
        
      </v-btn>

    </v-speed-dial>






          </v-card-text>

    <web-location-present-single class="" :location="artefact.location"></web-location-present-single>
</v-card>


<web-location-tab :artefact="artefact"  :isCollection="false" class="hidden-md-and-up ">
   

  <div class="description pa-3">
      <p>{{artefact.description[lang]}}</p>
  </div>











<v-layout row wrap justify-center class="">
    <div class="div1"  v-for="media in artefact.uploads" :key="media._id">
        <v-flex xs12 sm12 v-if="media.type ==='image'"> 
            <div class=" position:relative"  >
                <img class="img1" :src="media.data[0].url+'_single'" alt="">       
            </div>
        </v-flex>      
      <v-flex elevation-1 class="mt-3 mb-3" xs12 sm12 v-else-if="media.type === 'video'">
        <v-card>
         <div >
        <v-card-media>
      <div  class=""  >
        <!-- <d-player :video='{
                url: media.data[0].url,
                  }'
                :autoplay="false"
                :contextmenu="contextmenu"
                screenshot: true
                lang = "en"
                @play="play"
                ref="player">
        </d-player >   -->

        <video style="width:100%; height:100%" controls  >
  <source :src="media.data[0].url + '.mp4'" type="video/mp4">
  <source :src="media.data[0].url + '.webm'" type="video/webm">
  <source :src="media.data[0].url + '.m4v'" type="video/m4v">
  <source :src="media.data[0].url + '.ogg'" type="video/ogg">
Your browser does not support the video tag.
</video>
      </div>
      </v-card-media> 
      </div>    
      </v-card>
      </v-flex>











    
      <v-flex elevation-1  v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'mt-3 mb-3 img1' : true} " xs12 sm12 v-else-if="media.type === 'audio'">
            <div v-if="media.data.length != 0" class="ma-1 pa-3">  
      <!-- <v-layout row style="width:100%; overflow:hidden; white-space:normal">

      <v-layout  class="">
      
      <div  class="" style="width:100%; overflow:hidden" >
        <a-player elevation-0 class="aplayer-style" style="width:100%; overflow:hidden"  :music="{
                            title: media.data[0].originalName,
                            author: ' ',
                            url: media.data[0].url,
                            pic: 'http://lectii-photoshop.com/wp-content/uploads/photo-shop/Lectii_Articole/Grafica%20pentru%20site/Music%20Icon/Music%20Icon-31.jpg',    
                            }">
        </a-player>
      </div>
      </v-layout>
      </v-layout> -->

            <v-layout row elevation-3  v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'pa-1' : true} "  style="background-color:#FAFAFA">
                <div style="width:100%; background-color:#FAFAFA">
 <v-layout class="" row style="width:100%; white-space:normal; ">
                  <v-flex xs12>
                        <p> <i>{{media.data[0].originalName}}</i> </p>
                </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs12>
                    <audio controls style="width:100%; " class="audioPlayer">
                             <source :src="media.data[0].url" type="audio/ogg">
                            <source :src="media.data[0].url" type="audio/mpeg">
                                {{gLang[lang].artefactSingle.browser}}
                    </audio>
           </v-flex>
           
        

            </v-layout>
                </div>
            </v-layout>
      
            
 
         </div>
       
      </v-flex>








      
      <v-flex  class="  mt-2 mb-2 ml-1 mr-1"  xs12 sm12 v-else-if="media.type === 'pdf'">
          <div v-if="media.data.length != 0">  
      <v-layout row wrap justify-center>

          <v-flex xs12 sm10 md6 offset>
      <v-card>
          <v-list two-line>
              <v-list-tile >
            <v-list-tile-avatar >
              <v-icon class="blue white--text pt-2"> picture_as_pdf</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{media.data[0].originalName}}</v-list-tile-title>
              <v-list-tile-sub-title>{{artefact.meta.creationDate | date}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn :href="media.data[0].url" download icon ripple>
                <v-icon  color="grey lighten-1">file_download</v-icon>
              </v-btn>
              <v-btn @click="viewPDF = !viewPDF" icon ripple>
                <v-icon v-if="!viewPDF" color="grey lighten-1">visibility</v-icon>
                <v-icon v-else color="grey lighten-1">visibility_off</v-icon>
                
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          </v-list>

          <v-layout justify-center>
          <iframe v-if="viewPDF" :src=" 'http://docs.google.com/viewer?url=' + 'hera.uvt.ro' + media.data[0].url  +  '.pdf' + '&embedded=true'" width="320" height="450" style="border: none;"></iframe>
            
          </v-layout>

          
      </v-card></v-flex>

      </v-layout>


          </div>
      </v-flex>

      <!-- <v-flex  class="mr-0 pl-3 pt-1 mt-2 mb-2 pb-1 flex1"  xs12 sm12 v-else-if="media.type === 'pdf'">
          <div v-if="media.data.length != 0">   -->



      <!-- <v-layout row>

    

      <v-layout  class="">
      <div  class="pt-2 " style="width:100%"  >
        <v-layout row>
            <v-flex xs2>
        <v-btn small fab primary  :href="media.data[0].url" download><v-icon dark >picture_as_pdf</v-icon></v-btn>


            </v-flex>

            <v-flex xs10 style="position: relative;
    right: 5%;">
                <v-layout justify-center>
                    
            <a class="pdfText" > <b>{{media.data[0].originalName}}</b></a> <br>
                </v-layout>
                <v-layout justify-center>
                    
            <p class="pdfDate">{{artefact.meta.creationDate | date}}</p>
                </v-layout>

            </v-flex>
  
      </v-layout>
      </div>
      </v-layout>
      

      </v-layout> -->
    
          <!-- </div>

      </v-flex> -->

      
      <v-flex  class="mt-2 mb-2 mr-1 ml-1 pt-1 pb-1" xs12 sm12 v-else-if="media.type === 'text'">


      
      
      <div  class="" >
        <div class="description pt-3 pl-3 pr-3 pb-0">
      <p v-html="media.value[lang]"></p>
       </div>
      </div>

      </v-flex>

      

   
       </div>

     
</v-layout>



         <web-speed-dial-add v-if="isMod||isContrib"></web-speed-dial-add>


</web-location-tab> 

 
</v-flex>
     </v-layout>


</v-container>
</template>


<script>
// import VuePDFViewer from 'vue-instant-pdf-viewer';
import axios from "axios";
import VueAplayer from "vue-aplayer";
import VueDPlayer from "vue-dplayer";
export default {
	data() {
		return {
			once: true,
			isLoading: true,
			artefact: {
				_id: "",
				title: {
					en: "",
					sr: "",
					ro: ""
				},
				meta: {
					author: "",
					creationDate: ""
				},
				description: {
					en: "",
					sr: "",
					ro: ""
				},
				mainImg: [
					{
						url: ""
					}
				]
			},
			fetchError: null,
			viewPDF: false,
			direction: "left",
			fab: false,
			fling: false,
			hover: false,
			tabs: null,
			top: false,
			dialog: false,
			right: true,
			bottom: true,
			left: false,
			transition: "slide-y-reverse-transition",
			player: null,
			contextmenu: [
				{
					text: "",
					link: ""
				}
			]
		};
	},
	metaInfo() {
		return {
			title: this.sanitizeString(this.artefact.title[this.lang]),
			meta: [
				{
					vmid: "og:title",
					name: "og:title",
					content: this.sanitizeString(this.artefact.title[this.lang])
				},
				{ vmid: "og:type", name: "og:type", content: "article" },
				{
					vmid: "og:article:published_time",
					name: "og:article:published_time",
					content: this.sanitizeString(this.artefact.meta.creationDate)
				},
				{
					vmid: "og:article:author",
					name: "og:article:author",
					content: this.sanitizeString(this.artefact.meta.author)
				},
				{
					vmid: "og:article:section",
					name: "og:article:section",
					content: this.sanitizeString(this.artefact.title[this.lang])
				},
				{ vmid: "og:locale", name: "og:locale", content: "ro_RO" },
				{
					vmid: "og:locale:alternate",
					name: "og:locale:alternate",
					content: "sr_SR"
				},
				{
					vmid: "og:description",
					name: "og:description",
					content: this.sanitizeString(this.artefact.description[this.lang])
				},
				{
					vmid: "og:url",
					name: "og:url",
					content: "https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.artefact._id)
				},
				{
					vmid: "og:image",
					name: "og:image",
					content: "https://www.hera.uvt.ro" + this.artefact.mainImg[0].url
				},
				{ vmid: "og:site_name", name: "og:site_name", content: "HErA" }
			],
			script: [
				{
					innerHTML: `{ "@context": "http://schema.org",
          "@type": "Article",
          "author": "${this.sanitizeString(this.artefact.meta.author)}", 
          "dateCreated":"${this.sanitizeString(this.artefact.meta.creationDate)}", 
          "isFamilyFriendly":"true",
          "thumbnailUrl":"${"https://www.hera.uvt.ro" + this.artefact.mainImg[0].url}",
          "name": "${this.sanitizeString(this.artefact.title[this.lang])}",
          "description": "${this.sanitizeString(this.artefact.description[this.lang])}",
          "image": "${"https://www.hera.uvt.ro" + this.artefact.mainImg[0].url}",
          "url":"${"https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.artefact._id)}"
           
           }`,
					type: "application/ld+json"
				}
			]
		};
	},
	mounted() {
		window.scrollTo(0, 0);
		this.fetchData();
		//this.player = this.$refs.player.dp
	},
	props: ["id"],

	methods: {
		goToCollectionByName(col) {
			if (
				this.collections.find(cole => {
					return cole.title.en == col;
				})
			) {
				const id = this.collections.find(cole => {
					return cole.title.en == col;
				})._id;
				this.$router.push("/collections/" + id);
			} else return false;
		},
		getLanguageTranslation(col) {
			if (
				this.collections.find(cole => {
					return cole.title.en == col;
				})
			)
				return this.collections.find(cole => {
					return cole.title.en == col;
				}).title[this.lang];
			else return false;
		},
		sanitizeString(str) {
			str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
			return str.trim();
		},
		fetchData: function() {
			var self = this;
			return axios
				.get("/api/artefacts/" + this.id)
				.then(function(response) {
					if (response.data.name == "CastError") {
						self.$router.push("/404");
					} else {
						self.artefact = response.data;
						self.isLoading = false;
						self.$store.dispatch("updateArtefactVisited", {
							artefact: response.data,
							userId: (self.user && self.user != {} && self.user._id) ? self.user._id : self.$store.getters.getIdentifier,
							date: Date.now()
						});
					}
				})
				.catch(function(error) {
					self.fetchError = error;
				});
		},
		addToFav() {
			if (!this.artefact.favorite.includes(this.user._id)) {
				this.artefact.favorite.push(this.user._id);
				this.$store.dispatch("updateArtefact", this.artefact);
			} else {
				for (var i = this.artefact.favorite.length - 1; i >= 0; i--) {
					if (this.artefact.favorite[i] === this.user._id) {
						this.artefact.favorite.splice(i, 1);
						break; //<-- Uncomment  if only the first term has to be removed
					}
				}
				this.$store.dispatch("updateArtefact", this.artefact);
			}
		},
		//     moveButton(admin) {
		//     if(admin) {
		//       var btn = document.getElementById('bottom_button');
		//       btn.style.bottom = '65px';

		//     }
		//     else
		//     {
		//       var btn = document.getElementById('bottom_button');
		//       btn.style.bottom = '15px';
		//     }

		//   },
		imageClick: function(imageURL) {
			var modal = document.getElementById("myModal");
			var modalImg = document.getElementById("img01");
			modal.style.display = "block";
			modalImg.src = imageURL;
		},
		getScreenWidth() {
			return screen.width;
			console.log(screen.width);
			console.log(screen.availWidth);
			console.log(screen.systemXDPI);
		},
		acceptArtefact() {
			this.artefact.reviewed = true;
			this.$store.dispatch("updateArtefact", this.artefact);
			this.$store.dispatch("loadArtefacts");
		},
		deleteArtefact: function() {
			if ((this.isAdmin && !this.isAccepted) || (this.isMod && !this.isAccepted)) {
				this.$store.dispatch("deleteArtefact", this.artefact);
				this.$store.dispatch("loadArtefacts");
				this.$router.push("/tasks");
			} else {
				this.artefact.deleted = true;
				this.$store.dispatch("updateArtefact", this.artefact);
				this.$router.push("/");
			}

			// this.$store.dispatch("deleteArtefact", this.artefact);
			// this.$router.push("/");
			// axios.delete('http://localhost:3000/artefacts/'+this.id).then((response) => {
			//     this.$router.push("/artefacts");
			// },
			//     (err) => {
			//         console.log(err)
			//     })
		},
		// blabla(){
		//       this.$store.dispatch("loadArtefacts");
		//       this.onResize();
		// },
		spanClick: function() {
			var modal = document.getElementById("myModal");
			modal.style.display = "none";
		},
		widthChange: function() {
			var img = document.getElementById("myImg");
			img.style.width = "100px";
		},
		handleSize() {
			var img = document.getElementsByClassName("myImg");
			console.log(img[0]);
			var i = 0;
			for (i = 0; i < img.length; i++) {
				img[i].style.width = screen.width / 3.5 + "px";
				var height = img[i].style.width;
				img[i].style.height = height;
			}

			// var video = document.getElementById('video');
			// video.style.width = screen.width + 'px';
			// var height = video.style.width;
			// video.style.height = screen.width /2 + 'px';
		},
		handleVideoSize() {
			var video = document.getElementsByClassName("video");
			var videoContainer = document.getElementById("videoContainer");
			console.log(video[0]);
			var i = 0;
			var sum = 0;
			for (i = 0; i < video.length; i++) {
				var x = video[i].style.width / video[i].style.height;
				video[i].style.height = screen.width * x + "px";
				sum = sum + video[i].style.height;
				console.log(video[i].style.height);
				console.log(sum);
				console.log(sum);
				console.log(sum);
				console.log(sum);
				console.log(video[i].style.height);
				console.log(video[i].style.height);
				console.log(x);
			}

			videoContainer.style.height = sum + "px";

			// var video = document.getElementById('video');
			// video.style.width = screen.width + 'px';
			// var height = video.style.width;
			// video.style.height = screen.width /2 + 'px';
		},
		play() {
			console.log("play callback");
		}
	},
	created() {
		this.$store.dispatch("loadArtefacts");

	},
	updated: function() {
		this.handleSize();
	},
	computed: {
		lang() {
			return this.$store.getters.loadLang;
		},
		users() {
			return this.$store.getters.loadUsers;
		},
		favorited() {
			if (this.artefact.favorite) return this.artefact.favorite.includes(this.user._id);
			else return false;
		},
		isLoggedIn() {
			return this.$store.getters.isLoggedIn;
		},
		// artefact() {
		//   return this.$store.getters.loadArtefactSingle(this.id);
		// },
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		collections() {
			return this.$store.getters.loadAllCollections;
		},
		isAccepted() {
			return this.artefact.reviewed;
		},
		isAuthor() {
			return this.artefact.userId == this.user._id;
		},
		user() {
			return this.$store.getters.getUser;
		},
		isMod() {
			return this.$store.getters.isMod;
		},
		isContrib() {
			return this.$store.getters.isContrib;
		}
	},
	components: {
		"a-player": VueAplayer,
		"d-player": VueDPlayer
	},
	watch: {
		id() {
			this.isLoading = true;
			this.fetchData();
		},
		artefact() {
			setTimeout(() => {
				document.dispatchEvent(new Event("custom-post-render-event"));
			}, 1000);
		}
	}
};
</script>

  



<style scoped>
.header_gray{
      background-color: #f5f5f5;
}
.mainImg-overlay {
	background-color: rgba(0, 0, 0, 0.5);
	position: absolute;
	width: 100%;
	height: 100%;
}

#myImg,
#myImg2,
#myImg3,
#myImg4,
#myImg5,
#myImg6 {
	border-radius: 5px;
	cursor: pointer;
	transition: 0.3s;
}

#myImg:hover,
#myImg2:hover,
#myImg3:hover,
#myImg4:hover,
#myImg5:hover,
#myImg6:hover {
	opacity: 0.7;
}

/* The Modal (background) */
.modal {
	display: none; /* Hidden by default */
	position: fixed; /* Stay in place */
	z-index: 1; /* Sit on top */
	padding-top: 100px; /* Location of the box */
	left: 0;
	top: 0;
	width: 100%; /* Full width */
	height: 100%; /* Full height */
	overflow: auto; /* Enable scroll if needed */
	background-color: rgb(0, 0, 0); /* Fallback color */
	background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
	margin: auto;
	display: block;
	width: 80%;
	max-width: 700px;
}

/* Caption of Modal Image */
#caption {
	margin: auto;
	display: block;
	width: 80%;
	max-width: 700px;
	text-align: center;
	color: #ccc;
	padding: 10px 0;
	height: 150px;
}

/* Add Animation */
.modal-content,
#caption {
	-webkit-animation-name: zoom;
	-webkit-animation-duration: 0.6s;
	animation-name: zoom;
	animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
	from {
		-webkit-transform: scale(0);
	}
	to {
		-webkit-transform: scale(1);
	}
}

@keyframes zoom {
	from {
		transform: scale(0.1);
	}
	to {
		transform: scale(1);
	}
}

/* The Close Button */
.close {
	position: absolute;
	top: 15px;
	left: -27px;
	color: #f1f1f1;
	font-size: 40px;
	font-weight: bold;
	transition: 0.3s;
	background-color: transparent;
}

.close:hover,
.close:focus {
	color: #bbb;
	text-decoration: none;
	cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
	.modal-content {
		width: 100%;
	}
}

.icon-circle {
	border-radius: 32px;
}

.pdfText {
	text-decoration: none;
	color: black !important;
	outline: none;
}

.pdfDate {
	font-size: 0.8em;
	color: grey;
}

.uploadedFilesText {
	color: grey;
}

.headerIcons {
	position: absolute;
	top: 6%;
	right: 4%;
}

.description p {
	text-align: justify;
}

.v-list-tile-content {
	position: absolute;
	bottom: 12%;
	width: 85%;
}

.v-list-tile-title {
	height: auto;
	white-space: normal;
	overflow: visible;
}

.div1 {
	position: relative;
	width: 100%;
}

.img1 {
	width: 100%;
}

.aplayer-style {
	box-shadow: 0 0 0 0;
}

.flex1 {
	position: relative;
	width: 100%;
}

.smallScreenHeight {
	height: 80vh !important;
}

.largeScreenHeight {
	height: 55vh !important;
}

.noBoxShadow {
	box-shadow: none !important;
}

.addBorder {
	border-left: 1px solid #eeeeee;
	border-right: 1px solid #eeeeee;
}

/* .audioPlayer { 
  webkit-media-controls-play-button :  red; 
} */

.headerButtons:hover {
	opacity: 0.4;
}
</style>


<style>
.timeline-item {
	background: #fff;
	border-bottom: 1px solid #f2f2f2;
	padding: 25px;
	margin: 0 auto;
}

@keyframes placeHolderShimmer {
	0% {
		background-position: -468px 0;
	}
	100% {
		background-position: 468px 0;
	}
}

.animated-background {
	animation-duration: 1s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
	animation-name: placeHolderShimmer;
	animation-timing-function: linear;
	background: #f6f7f8;
	background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
	background-size: 800px 104px;
	height: 538px;
	position: relative;
	width: 1000px;
}

.background-masker {
	background: #fff;
	position: absolute;
}

/* Every thing below this is just positioning */

.background-masker.header-top {
	top: 400px;
	left: 0px;
	right: 0;
	height: 30px;
}

.background-masker.header-bottom {
	top: 480px;
	height: 9px;
	left: 0px;
	right: 0;
}

.background-masker.header-left {
	top: 450px;
	left: 0px;
	height: 8px;
	width: 100%;
}

/*  */

.background-masker.header-right {
	top: 509px;
	height: 9px;
	width: 100%;
	left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/ArtefactSingle.vue